/**
 * Banner Configuration
 * Manage all ad banners dari file ini untuk easy customization
 */

export const BANNER_CONFIG = {
  // Master switch: matikan semua banner sementara saat migrasi ke Adsense
  adsEnabled: true,

  // Tracking Result Page Banner
  trackingResultBanner: {
    enabled: true,
    type: "adsense",
    slot: "7170112492"
  },

  trackingOfferwallBanner: {
    enabled: true,
    type: "adsense",
    slot: "2229614061"
  },

  courierPageBanner: {
    enabled: true,
    type: "adsense",
    slot: "7170112492"
  },

  autoDetectPageBanner: {
    enabled: true,
    type: "adsense",
    slot: "7170112492"
  },

  // Ongkir Result Page Banner
  ongkirResultBanner: {
    enabled: true,
    type: "adsense",
    slot: "6296014526"
  },

  blogListBanner: {
    enabled: true,
    type: "adsense",
    slot: "7198166106"
  },

  blogInlineBanner: {
    enabled: true,
    type: "adsense",
    slot: "8483194167"
  },

  blogAfterContentBanner: {
    enabled: true,
    type: "adsense",
    slot: "7804670768"
  },

  kodeposAdsUnit: {
    enabled: true,
    type: "adsense",
    slot: "8446141851"
  },

  globalPromoBanners: [
    {
      id: "blibli-mei-2026",
      enabled: true,
      href: "https://atid.me/go/HmfaWSt4",
      imageSrc: "/banners/promo/promo-blibli-970x250.jpg",
      mobileImageSrc: "/banners/promo/promo-blibli-300x250.jpg",
      imageAlt: "Promo Blibli berlaku 25 sampai 27 Mei 2026",
      width: 970,
      height: 250,
      mobileWidth: 300,
      mobileHeight: 250,
      startsAt: "2026-05-25T00:00:00+07:00",
      endsAt: "2026-05-28T00:00:00+07:00",
    },
  ],
};

export function getBannerConfig(key) {
  const banner = BANNER_CONFIG[key];

  if (!banner) {
    return { enabled: false };
  }

  return {
    ...banner,
    enabled: BANNER_CONFIG.adsEnabled && banner.enabled,
  };
}

export function getTrackingBannerConfig() {
  return getBannerConfig("trackingResultBanner");
}

export function getTrackingOfferwallBannerConfig() {
  return getBannerConfig("trackingOfferwallBanner");
}

/**
 * Usage Examples:
 * 
 * // di TrackingResultPage.jsx:
 * <AdBanner {...BANNER_CONFIG.trackingResultBanner} />
 * 
 * // di OngkirResultPage.jsx:
 * <AdBanner {...BANNER_CONFIG.ongkirResultBanner} />
 * 
 * // Dengan rotating banners:
 * const bannerSrc = BANNER_CONFIG.getRandomBanner();
 * <AdBanner type="image" imageSrc={bannerSrc} imageAlt="Promo" />
 */
